module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-precomposed-609b3136db920edce92aad38097b4ae8.png";